import React, { useEffect, useState } from "react"
import { useFeatureFlagEnabled } from "posthog-js/react"
import { useNavigationContext } from "./NavigationContext"
import { useCMSReady } from "../../domain/CMS/useCMSReady"
import { FeatureFlag } from "../../domain/enums/featureFlags"
import Spinner from "../shared/components/Spinner"

const TRANSITION_DELAY_MS = 400
const DEFAULT_NAVIGATION_LOADING_TEXT =
  "Loading content and navigating, please wait."

export const NavigationLoadingOverlay: React.FC = () => {
  const isEnabled = !!useFeatureFlagEnabled(
    FeatureFlag.IsUIOptimizations12699Enabled,
  )
  const { isPending } = useNavigationContext()
  const [show, setShow] = useState(false)
  const { cms: cmsContent } = useCMSReady(["common"])

  const loadingText =
    cmsContent.common?.navigationLoadingText ?? DEFAULT_NAVIGATION_LOADING_TEXT

  useEffect(() => {
    if (!isPending) {
      setShow(false)
      return
    }
    const timer = setTimeout(() => setShow(true), TRANSITION_DELAY_MS)
    return () => clearTimeout(timer)
  }, [isPending])

  if (!isEnabled) return null

  return (
    <>
      <div
        role="status"
        aria-live="polite"
        aria-atomic="true"
        className="sr-only"
      >
        {isPending ? loadingText : ""}
      </div>
      {show && (
        <div className="fixed inset-0 z-50 bg-white/60 flex items-center justify-center pointer-events-auto">
          <div className="bg-gray-200 rounded-xl p-6 shadow-lg">
            <Spinner
              parentStyleOverrides="!h-fit pt-2"
              textStyleOverrides="!pb-0 text-gray-800"
            />
          </div>
        </div>
      )}
    </>
  )
}
